import { render, staticRenderFns } from "./BaseECharts.vue?vue&type=template&id=38bfb43c&scoped=true&"
import script from "./BaseECharts.vue?vue&type=script&lang=js&"
export * from "./BaseECharts.vue?vue&type=script&lang=js&"
import style0 from "./BaseECharts.vue?vue&type=style&index=0&id=38bfb43c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bfb43c",
  null
  
)

export default component.exports